import Router from 'next/router';

import { ENDPOINTS } from '@/settings/endpoints';

import Cookies from '../common/cookies';

const urlUnauthorizedPage = '/unauthorized';

const replaceUrlUnauthorized = (queryString:string): string => queryString.replace(urlUnauthorizedPage,'');

function redirectToSignIn(returnUrl?: string): void {
  const queryString = returnUrl && returnUrl.length > 0 ? `?returnUrl=${returnUrl}` : '';
  window.location.href = `${ENDPOINTS.accounts}${replaceUrlUnauthorized(queryString)}`;
}

function redirectToSignOut(): void {
  localStorage.clear();
  Cookies.removeItem('d');

  redirectToSignIn(window.location.href);
}

function redirectToUnauthorized(): void {
  Router.push(urlUnauthorizedPage);
}

export { redirectToSignIn, redirectToSignOut, redirectToUnauthorized };
